<template>
    <div
        class="list-wrapper"
        :class="{'search-mode' : contacts_filter.search_active}"
    >
        <SmartList ref="smart_list_component"
            @smartListItemsSet=onSmartListItemsSet
            @smartListItemsLoaded="emit('contactListLoaded')"
            :smart_list_items="contacts_filter.items"
        >
            <template #elements>
                <div v-for='contact in smart_list_items'
                :key="contact.id"
                class="contact"
                tabindex="0"
                :class="{[contact.type] : true , 'active' : (route.params.contact_id === contact.id && !contacts_selection.count) || contacts_selection.index[contact.id]}"
                v-context-menu="{action: onContactContextMenu, data : contact}"
                >
                    <div class="checkbox" v-if="contact.type !== 'letter'">
                        <input :id="'rtct_' + contact.id"  type="checkbox" @click.prevent.stop="null" :checked="contacts_selection.index[contact.id]" tabindex="-1">
                        <label :for="'rtct_' + contact.id" @click='onContactToggle(contact)' tabindex="-1"></label>
                    </div>
                    <a @click.prevent="onContactClick(contact)" tabindex="-1" v-if="contact.type !== 'letter'" role="button">
                        <span class="name">{{contact.name}}</span>
                        <span class="match" v-if="contacts_filter.search_active && contacts_filter.matches[contact.id]">
                            <span>{{contacts_filter.matches[contact.id][0]}}</span>
                            <strong>{{contacts_filter.matches[contact.id][1]}}</strong>
                            <span>{{contacts_filter.matches[contact.id][2]}}</span>
                        </span>
                    </a>
                    <div v-if="contact.type === 'letter'">
                      <span>{{contact.name}}</span>
                    </div>
                </div>
            </template>
        </SmartList>
    </div>
</template>

<script setup>
  import {ref } from 'vue';
  import {defineExpose, defineProps, defineEmits} from 'vue';
  import {useRoute}                               from 'vue-router'
  import SmartList                                from '@/vue/Elements/Tools/SmartList.vue';

  const props = defineProps({
    contacts_filter   : {},
    contacts_selection: {},
  })

  const smart_list_component = ref();
  const smart_list_items     = ref();
  const route                = useRoute();

  const emit = defineEmits([
    'contactSelect',
    'contactUnselect',
    'contactContextMenu',
    'contactClick',
    'contactListLoaded'
    // 'contactsListRouterContactScroll',
  ])

  const onSmartListItemsSet = (items) => {
    setSmartListItems(items);
  }

  // const onSmartListViewportItemIndexSet = (contact) => {
  //   emit('contactsListRouterContactScroll', contact);
  // }

  const onContactClick = (contact) => {
    emit('contactClick', contact)
  }

  const onContactToggle = (contact) => {
    (props.contacts_selection.exists(contact.id))
      ? setContactUnselect(contact)
      : setContactSelect(contact);
  }

  const setContactSelect = (contact) => {
    props.contacts_selection.add(contact);
    emit('contactSelect', contact);
  }

  const setContactUnselect = (contact) => {
    props.contacts_selection.delete(contact.id);
    emit('contactUnselect', contact);
  }

  const setSmartListItems = (items) => {
    smart_list_items.value = items;
  }

  const onContactContextMenu = (contact) => {
    emit('contactContextMenu', contact);
  }

  const scrollToContact = (contact) => {
    smart_list_component.value.scrollToItem(contact);
  }

  const scrollToTop = () => {
    smart_list_component.value.scrollToIndex(0);
  }

  defineExpose({
    scrollToContact: scrollToContact,
    scrollToTop: scrollToTop,
  })

</script>
